<div>
  <h5 class="sub-title mb-3">{{ datas._title }}</h5>
  <div class="form-rows">
    <p class="break">{{ datas._status }}</p>
  </div>
  <div class="text-center mt-5">
    <button class="mr-2" mat-raised-button (click)="cancelReason()">OK</button>
  </div>
</div>
